import { makeStyles } from "@material-ui/core/styles";
import { getTokens } from "../../styles/tokens";

/* Estilos comuns dos modais de nó de fluxo (área de envio de mídia, prévia,
 * linha de marcar, controle deslizante). Complementa o panelKit. */
export const useFlowModalStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  return {
    // área tracejada de envio de arquivo, com a prévia dentro
    upload: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 12,
      minHeight: 132,
      padding: 16,
      border: `1px dashed ${t.lineStrong}`,
      borderRadius: t.radius.md,
      backgroundColor: t.muted,
      textAlign: "center",
    },
    uploadHint: {
      fontFamily: t.font,
      fontSize: 12.5,
      lineHeight: 1.45,
      color: t.textSecondary,
    },
    preview: {
      display: "block",
      maxWidth: "100%",
      maxHeight: 320,
      borderRadius: t.radius.sm,
    },
    audio: { width: "100%", maxWidth: 420 },
    // caixa de marcar + frase
    checkRow: {
      display: "flex",
      alignItems: "center",
      gap: 4,
      marginLeft: -9,
      fontFamily: t.font,
      fontSize: 13.5,
      color: t.text,
      cursor: "pointer",
    },
    loading: { display: "flex", justifyContent: "center", padding: "8px 0" },
    // randomizador: percentual de cada saída nas pontas do controle
    sliderRow: {
      display: "flex",
      alignItems: "center",
      gap: 18,
      padding: "18px 4px 6px",
    },
    sliderValue: {
      flex: "none",
      minWidth: 46,
      textAlign: "center",
      fontFamily: t.font,
      fontSize: 15,
      fontWeight: 600,
      fontVariantNumeric: "tabular-nums",
      color: t.text,
    },
    sliderCaption: {
      display: "flex",
      justifyContent: "space-between",
      fontFamily: t.font,
      fontSize: 12,
      color: t.textSecondary,
    },
    // lista de itens escolhidos (tags, opções)
    chips: { display: "flex", flexWrap: "wrap", gap: 6 },
  };
});

export default useFlowModalStyles;
